import { FC, useCallback, useState, useMemo } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Skeleton } from 'antd';
import { useQueryFiles } from 'Hooks/files/useQueryFiles';
import { useQueryMoveFileMove } from 'Hooks/files/useQueryMoveFileMove';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { IListFilesRequest } from 'Data/interfaces/ListagemArquivos/IListFilesRequest';
import { IMoveFileRequest } from 'Data/interfaces/ListagemArquivos/IMoveFileRequest';
import { GetDisciplineApiFolderIdFromBreadCrumb } from 'Utils/ObraUtils';
import { Icon } from 'Components/UI';
import { Container } from './styles';

export interface IFolderInfo {
  icon?: React.ReactNode;
  description?: string;
  href?: string;
}

export interface IMoverArquivos {
  constructionSiteId: number;
  folderId: string;
  breadCrumbId: string | null;
  fileId?: string;
  position?: {
    x: number;
    y: number;
  };
  toggleDropdown: () => void;
}

const MoverArquivos: FC<Props> = ({
  constructionSiteId,
  folderId,
  fileId,
  breadCrumbId,
  position,
  selectedEditRowKeys,
  toggleDropdown,
}) => {
  const [currentFolderId, setCurrentFolderId] = useState(folderId);
  const [currentBreadCrumbId, setCurrentBreadCrumbId] = useState<string | number | null>(breadCrumbId);
  const request = useMemo(() => {
    const result: IListFilesRequest = {
      constructionSiteId,
      folderId: currentFolderId,
      onlyFolder: true,
    };
    if (currentBreadCrumbId) {
      result['breadCrumbId'] = currentBreadCrumbId;
    }
    return result;
  }, [constructionSiteId, currentFolderId, currentBreadCrumbId]);
  const {
    data: filesData,
    isFetching: isLoadingFileList,
  } = useQueryFiles(request);
  const { moveFile } = useQueryMoveFileMove();

  const searchFolder = useCallback((
    newFolderId: string,
    searchBreadCrumbId?: string | number | null,
  ) => {
    if (newFolderId) {
      setCurrentFolderId(newFolderId);
      if (searchBreadCrumbId) { setCurrentBreadCrumbId(searchBreadCrumbId); }
    }
  }, []);

  const handleMoveFiles = () => {
    if (!filesData?.BreadCrumbItem?.Identifier || !breadCrumbId) { return; }

    if (breadCrumbId !== filesData.BreadCrumbItem.Identifier) {

      const filesId = fileId ? [fileId] : selectedEditRowKeys;

      const moveRequest: IMoveFileRequest = {
        ConstructionSiteId: constructionSiteId || 0,
        CurrentFolderId: breadCrumbId,
        FilesId: filesId,
        NewFolderId: filesData.BreadCrumbItem.Identifier || '',
        DisciplineApiFolderId: GetDisciplineApiFolderIdFromBreadCrumb(filesData.BreadCrumbItem),
        FileRenames: {},
      };

      moveFile(moveRequest);
      toggleDropdown();
    }
  };

  return (
    <Container position={position}>
      <div className='header' >
        {isLoadingFileList && (
          <div className='skeletonTitle' >
            <Skeleton paragraph={false} active />
          </div>
        )}
        {!isLoadingFileList && (
          <>
            {filesData?.BreadCrumbItem?.PreviousItem && (
              <span
                className='backButton'
                onClick={() => searchFolder(
                  String(filesData?.BreadCrumbItem?.PreviousItem?.Identifier),
                  filesData?.BreadCrumbItem?.PreviousItem?.PreviousItem?.BreadCrumbItemId ||
                  filesData?.BreadCrumbItem?.PreviousItem?.PreviousItem?.BreadCrumbItemIdDropbox,
                )}
              >
                <Icon icon='voltar' color='branco' customSize={11} />
              </span>
            )}
            <span className='titleCurrentFolder'>
              {filesData?.BreadCrumbItem?.Name}
            </span>
          </>
        )}
        <span className='closeButton' onClick={toggleDropdown}>
          <Icon icon='error' color='branco' customSize={18} />
        </span>
      </div>
      <div className='body'>
        {isLoadingFileList && (
          <div className='skeletonFiles' >
            <Skeleton paragraph={{ rows: 10, width: '50px' }} active />
          </div>
        )}
        {!isLoadingFileList && filesData?.ListFiles?.map((folder) => (
          <div
            className='folderItem'
            onClick={() => searchFolder(
              String(folder.Identifier.ApiId),
              filesData?.BreadCrumbItem?.BreadCrumbItemId ||
              filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox,
            )}
          >
            <Icon icon='arquivar' color='cinzaPadrao' customSize={15} />
            <span className='titleFolderItem' >
              {folder.Name}
            </span>
          </div>
        ))}
      </div>
      <div
        className='footer'
        onClick={handleMoveFiles}
      >
        <span className={`moveFileButton
          ${isLoadingFileList
            ? 'disabled'
            : ''}`}
        >
          Mover aqui
        </span>
      </div>
    </Container>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.listagemArquivos,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & IMoverArquivos;

export default connector(MoverArquivos);
